import React from 'react';
import { View } from 'react-native';
import RollingAverageChart, {
  RollingAverageDataSet
} from '../../components/charts/RollingAverageChart';

const rollingAverageChartSampleData: Array<RollingAverageDataSet> = [
  {
    caption: 'Without Dreem Capsule',
    chartData: [
      { x: 1, y: 5 },
      { x: 2, y: 6 },
      { x: 3, y: 4.5 },
      { x: 4, y: 6.5 },
      { x: 5, y: 5 },
      { x: 6, y: 6 },
      { x: 7, y: 5 },
      { x: 15, y: 5 },
      { x: 16, y: 6 },
      { x: 17, y: 4.5 },
      { x: 18, y: 6.5 },
      { x: 19, y: 5 },
      { x: 20, y: 6 },
      { x: 21, y: 5 }
    ]
  },
  {
    caption: 'With Dreem Capsule',
    chartData: [
      { x: 8, y: 6 },
      { x: 9, y: 7 },
      { x: 10, y: 5.5 },
      { x: 11, y: 7 },
      { x: 12, y: 6.5 },
      { x: 13, y: 7 },
      { x: 14, y: 6 }
    ]
  }
];

const RollingAverageChartExampleScreen = () => {
  return (
    <View>
      <RollingAverageChart
        label='SLEEP DURATION (HRS)'
        dataSets={rollingAverageChartSampleData}
        goal={7.5}
        currentDay={21}
      />
    </View>
  );
};

export default RollingAverageChartExampleScreen;
